/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/AgenticServiceConstants';
import utils from '../../../../common/utils';

export default class GetAgenticGraphListService extends BaseService {
  constructor() {
    super(constants.GET_AGENTIC_GRAPHS, 'GetAgenticGraphListServiceStatus');
  }

  async handleEvent(eventName, event) {
    const { headers } = utils.buildRequestPartsFromPayload(event);
    const requestConfig = { headers };
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get('/graphs', { ...requestConfig, headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get('/graphs', requestConfig);
  }

  handleResponse(response) {
    const { data } = response;
    const agenticGraphListModel = Framework.getStoreRegistry().getStore('agenticGraphListModel');

    if (data && data.success) {
      agenticGraphListModel.setGraphs({
        graphs: data.graphs || []
      });
    } else {
      agenticGraphListModel.setError(data?.message || 'Failed to load graph list');
    }
  }

  handleError(error) {
    const agenticGraphListModel = Framework.getStoreRegistry().getStore('agenticGraphListModel');
    const { response } = error;

    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      agenticGraphListModel.setError(data?.message || 'Failed to load graph list');
    } else if (error.message === 'timeout of 60000ms exceeded') {
      agenticGraphListModel.setError('Request timeout. Please try again.');
    } else {
      agenticGraphListModel.setError(error.message || 'Failed to load graph list');
    }
  }
}
